<template>
  <div id="wrapper">
    <app-page-loader></app-page-loader> 

    <app-user-dashboard v-if="pageType == 'dashboard'">
      <router-view />
    </app-user-dashboard>

    <admin-default v-else-if="pageType == 'admin'">
      <router-view />
    </admin-default>

    <app-user-default v-else>
      <router-view />
    </app-user-default>
  </div>
</template>

<script>
  /* eslint-disable no-console */
  import { UserDefault, AdminDefault, UserDashboard } from './components/layout';
  import('../src/assets/js/custom.js');
  import PageLoader from './components/ui/PageLoader.vue';

  export default {
    name: 'app',
    components: {
      'app-user-default': UserDefault,
      'admin-default': AdminDefault,
      'app-page-loader': PageLoader,
      'app-user-dashboard': UserDashboard,
    },
    data() {
      return {
        isLoaded: false,
      };
    },

    computed: {
      pageType: function() {
        let currentPath = this.$route.path;
        if (currentPath.substring(1, 10) == 'dashboard') return 'dashboard';
        if (currentPath.substring(1, 6) == 'admin') return 'admin';

        return 'home';
      },
    }, 

    created() {
      var scripts = [
        'https://code.jquery.com/jquery-3.5.0.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/jQuery.mmenu/6.1.8/jquery.mmenu.js',
        'https://cdnjs.cloudflare.com/ajax/libs/tippy.js/2.5.2/tippy.all.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/simplebar/2.6.1/simplebar.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-slider/10.0.2/bootstrap-slider.min.js',

        'https://cdnjs.cloudflare.com/ajax/libs/clipboard.js/2.0.0/clipboard.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.0.0/jquery.magnific-popup.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-select/1.12.4/js/bootstrap-select.min.js',
        //  'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js',
      ];

      scripts.forEach((script) => {
        let tag = document.createElement('script');
        tag.setAttribute('src', script);
        document.head.appendChild(tag);
      });
    },
  };
</script>

<style>
  @import './assets/css/bootstrap.css';
  @import './assets/css/style.css';
  @import './assets/css/blue.css';
  @import './assets/css/custom.css';
</style>
